import { render, staticRenderFns } from "./FlashCard.vue?vue&type=template&id=5f3c0794&"
import script from "@/scripts/FlashCard/FlashCardDetail/components/FlashCard/FlashCard?vue&type=script&lang=js&"
export * from "@/scripts/FlashCard/FlashCardDetail/components/FlashCard/FlashCard?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports